export default __webpack_public_path__ + "static/media/salesforce.1b7e44fc.svg";